export default __webpack_public_path__ + "static/media/warning--bridge--g1.5beed47f.png";